export const SPREADSHEET_TABLE_SET_SELECTED_ROWS = 'SPREADSHEET_TABLE/SET_SELECTED_ROWS';
export const SPREADSHEET_TABLE_REMOVE_ROWS_REQUEST = 'SPREADSHEET_TABLE/REMOVE_ROWS_REQUEST';
export const SPREADSHEET_TABLE_REMOVE_SELECTED_ROWS_REQUEST = 'SPREADSHEET_TABLE/REMOVE_SELECTED_ROWS_REQUEST';
export const SPREADSHEET_TABLE_SET_IS_ROWS_REMOVE_IN_PROGRESS = 'SPREADSHEET_TABLE/SET_IS_ROWS_REMOVE_IN_PROGRESS';
export const SPREADSHEET_TABLE_SEARCH_SET_QUERY = 'SPREADSHEET_TABLE_SEARCH_SET_QUERY';
